// Action creators for gameReducer.
// Components call these via dispatch from GameProvider context.

// Room
export const setRoom = (gameId, uid) => ({ type: 'SET_ROOM', gameId, uid });
export const clearRoom = () => ({ type: 'CLEAR_ROOM' });

// Firebase sync
export const syncPhase = (phase) => ({ type: 'SYNC_PHASE', phase });
export const syncMeta = (meta) => ({ type: 'SYNC_META', meta });
export const syncPlayers = (players) => ({ type: 'SYNC_PLAYERS', players });
export const syncHand = (hand, isNewDeal = false) => ({ type: 'SYNC_HAND', hand, isNewDeal });
export const syncReady = (readyStatus) => ({ type: 'SYNC_READY', readyStatus });
export const syncNemCompleted = (nemCompleted) => ({ type: 'SYNC_NEM_COMPLETED', nemCompleted });
export const syncSessionTotals = (totals) => ({ type: 'SYNC_SESSION_TOTALS', totals });
export const syncRoundHistory = (roundHistory) => ({ type: 'SYNC_ROUND_HISTORY', roundHistory });
export const syncRevealedArrangements = (arrangements) => ({ type: 'SYNC_REVEALED_ARRANGEMENTS', arrangements });
export const syncRoundResults = (results) => ({ type: 'SYNC_ROUND_RESULTS', results });
export const syncBetweenRounds = (data) => ({ type: 'SYNC_BETWEEN_ROUNDS', ...data });
export const syncDealerSuccession = (data) => ({ type: 'SYNC_DEALER_SUCCESSION', data });
export const syncConnection = (connected) => ({ type: 'SYNC_CONNECTION', connected });

// Card movement
export const moveCardToRow = (card, row, slotIndex) => ({ type: 'MOVE_CARD_TO_ROW', card, row, slotIndex });
export const moveCardToStaging = (card) => ({ type: 'MOVE_CARD_TO_STAGING', card });
export const tapStagingCard = (card) => ({ type: 'TAP_STAGING_CARD', card });
export const autoPlaceCard = (card) => ({ type: 'AUTO_PLACE_CARD', card });
export const tapRowCard = (card, row, index) => ({ type: 'TAP_ROW_CARD', card, row, index });
export const tapSlot = (row, index) => ({ type: 'TAP_SLOT', row, index });
export const returnRowCardToStaging = (row, index) => ({ type: 'RETURN_ROW_CARD_TO_STAGING', row, index });
export const swapCards = (card1, card2, row1, row2) => ({ type: 'SWAP_CARDS', card1, card2, row1, row2 });
export const resetArrangement = () => ({ type: 'RESET_ARRANGEMENT' });
export const setArrangement = (arrangement) => ({ type: 'SET_ARRANGEMENT', arrangement });
export const setHand = (hand) => ({ type: 'SET_HAND', hand });

// UI state
export const setSelectedCard = (card) => ({ type: 'SET_SELECTED_CARD', card });
export const setDragState = (dragState) => ({ type: 'SET_DRAG_STATE', dragState });
export const setViolationRows = (rows) => ({ type: 'SET_VIOLATION_ROWS', rows });
export const setAutoWinHand = (autoWinHand) => ({ type: 'SET_AUTO_WIN_HAND', autoWinHand });
export const setShowdownStep = (step) => ({ type: 'SET_SHOWDOWN_STEP', step });

// Nem
export const nemDiscard = (discardedIds, newCards) => ({ type: 'NEM_DISCARD', discardedIds, newCards });
export const clearNemState = () => ({ type: 'CLEAR_NEM_STATE' });

// Error
export const setError = (error) => ({ type: 'SET_ERROR', error });
export const clearError = () => ({ type: 'CLEAR_ERROR' });
